import React from 'react';
import { noop } from '@ajaibid/utils';
import VERIFYING_EMAIL_ACCOUNT from 'Image/verifying-email-account-popup.png';
import { bool, func } from 'prop-types';
import PopupDialog from './PopUpDialog';

const PopUpEmailVerification = ({ onActionPrimaryClick, display }) => (
  <PopupDialog
    actionPrimaryText="Mengerti"
    align="center"
    display={display}
    disabledPrimaryAction={false}
    disabledSecondaryAction={false}
    onActionPrimaryClick={onActionPrimaryClick}
    image={VERIFYING_EMAIL_ACCOUNT}
    subtitle="Klik link verifikasi yang telah dikirimkan ke email yang kamu daftarkan."
    title="Verifikasi email sekarang"
    variantPrimary="primary"
  />
);

PopUpEmailVerification.propTypes = {
  onActionPrimaryClick: func,
  display: bool,
};

PopUpEmailVerification.defaultProps = {
  onActionPrimaryClick: noop,
  display: true,
};

export default PopUpEmailVerification;
